module.exports = __webpack_public_path__ + "static/media/securite.a96dc6a3.png";